
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 19 23","fill":"#fff","fill-rule":"evenodd","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('use',{attrs:{"xlink:href":"#storybook","x":".5","y":".5"}}),_c('symbol',{attrs:{"id":"storybook","overflow":"visible"}},[_c('g',{attrs:{"stroke":"none"}},[_c('path',{attrs:{"d":"M.682 20.272L.001 2.113A1.106 1.106 0 011.038.968L16.483.002a1.107 1.107 0 011.174 1.035l.002.069v19.788c0 .611-.495 1.106-1.106 1.106l-.05-.001-14.764-.663a1.106 1.106 0 01-1.056-1.063z","fill":"#ff4785"}}),_c('path',{attrs:{"d":"M13.039 2.704l.105-2.537L15.266 0l.091 2.617a.167.167 0 01-.159.171.169.169 0 01-.108-.035l-.818-.644-.969.735a.165.165 0 01-.231-.032.165.165 0 01-.034-.107zm-2.713 5.589c0 .43 2.898.224 3.288-.078 0-2.93-1.572-4.47-4.452-4.47s-4.493 1.564-4.493 3.91c0 4.086 5.514 4.164 5.514 6.392 0 .626-.307.997-.98.997-.878 0-1.225-.448-1.185-1.973 0-.331-3.349-.434-3.451 0-.26 3.695 2.042 4.761 4.676 4.761 2.553 0 4.554-1.361 4.554-3.824 0-4.379-5.595-4.262-5.595-6.431 0-.88.654-.997 1.041-.997.409 0 1.144.072 1.083 1.714z","fill-rule":"nonzero"}})])])])
          )
        }
      }
    